import { Link, useNavigate } from "react-router-dom";
import ContentPage from "../../Content";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import DataTable from "react-data-table-component";
import separateNumber from "../../../utils/separateur";
import ExportExcel from "../../../utils/ExcelExport";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";
import moment from "moment";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function TransactionAdvPage(){
  const [dateTime,setDateTime] = useState(new Date()) ;
  const [itemsList,setItemsList] = useState([]);
  const [itemsListFilter,setItemsListFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateDebut,setDateDebut] = useState('');
  const [dateFin,setDateFin] = useState(''); 


  const columns = [

    {
      name: "MARCHAND RECHARGES",
      selector : row =>( 
        <>
        <img src="../../../assets/images/faces-clipart/pic-1.png" alt="image" />
        <b>{row.MarchandRecharges}</b>

        </>
      )
    },

    {
      name: "DATE CREATION",
      selector : row => moment(row.DateCreation).format('Do MMMM YYYY H:m')
    },

    {
      name: "MONTANT",
      selector : row => <b className="text-danger">{separateNumber(row.Montant)}</b>
    },

    // {
    //   name: "TERRITOIRES",
    //   selector : row => row.NomTerritoire,
    // },
    // {
    //   name: "SECTEURS",
    //   selector : row => row.NomSecteur
    // },
    {
      name: "SOLDE",
      selector : row => <b className="text-dark">{separateNumber(row.SoldeMomo)}</b>
    },
    {
      name: "SOLDE DEBUT",
      selector : row => <b className="text-dark">{separateNumber(row.SoldeMinimumDebut)}</b>
    },
    {
      name: "SOLDE FIN",
      selector : row => <b className="text-dark">{separateNumber(row.SoldeMaximumFin)}</b>
    },

    {
      name: "RETOUR SITE",
      selector : row => <b className="text-success">{separateNumber(row.RetoursSites)}</b>
    },

    // {
    //   name: "STATUT",
    //   selector : row => (
    //     <>
    //      {row.is_active == 1 && (
    //     <span className="badge bg-success">Actif</span>
    //     )}
    //     {row.status == 0 && (
    //         <span className="badge bg-danger">Inactif</span>
    //     )}
    //     </>
    //   )
    // },



];
    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'PAGE TRANSACTION ADV')){
          navigate('/page-no-found');
      }
  },[user]);

  useEffect(()=>{
    fetchItemsList(dateTime);
  },[]);
  const fetchItemsList = async (date_debut,date_fin)=>{
    setLoading(true);
    try {
        axios.post(url.base+'/get_transaction_adv',{date_debut:moment(date_debut).format('YYYY-MM-DD'),date_fin:moment(date_fin).format('YYYY-MM-DD')},{
            headers:{
                'Content-Type':'application/json',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                
            },
        }).then((resp)=>{

            if(resp.status == 200){
                setItemsList(resp.data);
                setItemsListFilter(resp.data);
            }
            setLoading(false);
        })
    } catch (error) {
        setLoading(false);
    }
}

const handleFilter=(event)=>{
  const datas = itemsListFilter?.filter(row => row.MarchandRecharges.toLowerCase().includes(event.target.value.toLowerCase() ) || row.NumeroRecharges.toLowerCase().includes(event.target.value.toLowerCase()) )  ;
  setItemsList(datas);
}

const handleFilterDate=(event)=>{
  const dateValue = event.target.value;
  if(event.target.value !== ""){
      setDateTime(dateValue);
      setDateFin(dateValue)
      fetchItemsList(dateDebut,dateValue);
  }

  
}
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Page</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Listes des transactions ADV</p>
                  </a>
                </div>
                
              </div>
              <div class="header-left">
                {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-commercial"> Ajouter un commercial</Link> */}
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                <div class="card-header bg-warning bg-gradient">
                      <div class="row">
                          <div class=" col-lg-3 col-md-6">
                              <input type="search" class="form-control " placeholder="Recherche..." onChange={handleFilter}/>
                          </div>
                          <div class=" col-lg-3 col-md-3">
                              <input type="date" class="form-control"  onChange={(e)=>setDateDebut(e.target.value)}/>
                          </div>
                          <div class=" col-lg-3 col-md-3">
                              <input type="date" class="form-control"  onChange={handleFilterDate}/>
                          </div>
                          <div class=" col-lg-3 col-md-3">
                            <ExportExcel excelData={itemsList} filename={"LISTE DES TRANSACTIONS ADV"}  title={"Télécharger"} color={"btn-success"}/>
                          </div>
                  </div>
                  </div>
                  <div class="card-body">
                    <h4 class="card-title">TRANSACTIONS ADV</h4>
                    <div class="table-responsive">
                    <DataTable 
                          columns={columns} 
                          data={itemsList}
                          customStyles={customerStyle}
                          pagination
                          selectableRows
                          progressPending={loading}
                          progressComponent={
                              <>
                              <div class="text-center">
                                  <div class="spinner-border" role="status">
                                  {/* <span class="visually-hidden">Loading...</span> */}
                                  </div>
                              </div>
                              </>
                          } 
                          fixedHeaderScrollHeight="70vh"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ContentPage>
        </>
    )
}
export default TransactionAdvPage;